// removed by extract-text-webpack-plugin
module.exports = {"StickyTable":"StickyTable--SJQ3d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table.scss
// module id = 73
// module chunks = 1